import { requestConfig } from "../config.js";

/**
 * Получить идентификаторы договора и билинга
 *
 * @param {String} processKey
 */
export async function apiFetchContractBillingIds(processKey) {
  const response = await requestConfig.get("/api/v0/master/contract_by_process_key/", {
    params: {
      process_key: processKey,
    },
  });

  return response.data?.detail;
}

/**
 * Получить детальную информацию по договору.
 * В рамках данного запроса можно воспользоваться опциональным ключом flags
 * в случае если нужно получить объект с перечисленными в массиве flags ключами
 *
 * @param {Object} data
 * @param {Array<Object>} data.contracts
 * @param {Array<String>} [data.flags]
 */
export async function apiFetchContract(data) {
  const response = await requestConfig.post("/api/v0/contract_info/get_contract_info/", data);

  return response;
}

/**
 * Привязка договора к процессу
 *
 * @param {String} apiKey
 * @param {Number} contractNumber
 */
export async function apiBindContractToProcess(apiKey, contractNumber) {
  await requestConfig.post("/api/v0/master/mobile_connect/binding_contract/", {
    key: apiKey,
    contract_number: contractNumber,
  });
}
